import {
  ADMIN_CREW_REPORT_FILE_NAME_PATTERN,
  ADMIN_CREW_REPORT_FILE_NAME_GUIDANCE,
  ADMIN_CREW_REPORT_WORKBOOK_HEADERS,
  ADMIN_CREW_REPORT_HEADER_WHITESPACE_PATTERN,
  ADMIN_CREW_REPORT_WORKBOOK_HEADER_GUIDANCE,
} from "./admin-crew-report.constants";

export function getAdminCrewReportImoFromFileName(fileName: string): string {
  const match = ADMIN_CREW_REPORT_FILE_NAME_PATTERN.exec(fileName);
  if (!match?.[1] || match[0] !== fileName) throw new Error(ADMIN_CREW_REPORT_FILE_NAME_GUIDANCE);
  return match[1];
}

export function getAdminCrewReportWorkbookColumnOffset(headers: unknown[]): number {
  const values = headers.map((value) =>
    String(value ?? "")
      .trim()
      .replace(ADMIN_CREW_REPORT_HEADER_WHITESPACE_PATTERN, " ")
      .toLowerCase(),
  );
  const offset = values[0] === "vessel imo" ? 1 : 0;
  if (
    !ADMIN_CREW_REPORT_WORKBOOK_HEADERS.every((accepted, index) =>
      (accepted as readonly string[]).includes(values[index + offset] ?? ""),
    )
  ) {
    throw new Error(ADMIN_CREW_REPORT_WORKBOOK_HEADER_GUIDANCE);
  }
  return offset;
}
